export default "__VITE_ASSET__6bb98259__"